export default "__VITE_PUBLIC_ASSET__2c670a6a__"